import { useSearchParams } from 'react-router';
import { PageContainer } from '@/components/ui/page-container';
import { PageHeader } from '@/components/ui/page-header';
import { NotificationRules } from '@/components/notifications/NotificationRules.tsx';
import { NotificationDestinations } from '@/components/notifications/NotificationDestinations.tsx';
import { NotificationDeliveryLog } from '@/components/notifications/NotificationDeliveryLog.tsx';

/**
 * The pages of `/notifications` that are a header plus one existing component.
 *
 * Kept together because that is all each of them is; splitting near-identical
 * wrappers across files would be filing, not structure. The organization's routing,
 * shared destinations and PSA pages moved to Organization Admin
 * (`pages/settings/SettingsPages.tsx`).
 */

export function RulesPage() {
  // `?rule=` is how a notification email's "Manage your notification rules" link
  // arrives: the rule that sent it, picked out.
  const [params] = useSearchParams();
  return (
    <PageContainer width="medium">
      <PageHeader
        title="Notification rules"
        subtitle="What reaches you, and where. Rules add up — for “or”, add another."
      />
      <NotificationRules namedRuleId={params.get('rule')} />
    </PageContainer>
  );
}

export function DestinationsPage() {
  return (
    <PageContainer width="medium">
      <PageHeader title="Destinations" subtitle="The addresses and browsers your rules can point at" />
      <NotificationDestinations />
    </PageContainer>
  );
}

export function DeliveryLogPage() {
  // `?eventId=` is how the inbox's "Delivery details" link arrives. A different
  // authorization path server-side — it authorizes the event first — so this can
  // legitimately come back empty for an event the caller may not read.
  const [params] = useSearchParams();
  const eventId = params.get('eventId');

  return (
    <PageContainer width="medium">
      <PageHeader
        title={eventId ? 'Delivery details' : 'Delivery log'}
        subtitle={
          eventId
            ? 'Every channel this notification was routed to — including the ones it skipped, and why'
            : 'What was sent to you, what wasn’t, and why'
        }
      />
      <NotificationDeliveryLog eventId={eventId} />
    </PageContainer>
  );
}
